import time_mobi from "../../../assets/images/NewEvent/time_mobi.webp";
import time_pc from "../../../assets/images/NewEvent/time_pc.webp";
import ar_white from "../../../assets/images/Introduction/ar_white.svg";
import home_white from "../../../assets/images/Introduction/home_white.svg";

function removeColorStyle(html) {
  return html.replace(
    /(<[^>]+style\s*=\s*['"][^'"]*)color\s*:\s*[^'";]+(;?[^'"]*['"][^>]*>)/gi,
    function (match, prefix, suffix) {
      let modifiedStyle =
        prefix.replace(/color\s*:\s*[^'";]+(;?)/gi, "") + suffix;
      return modifiedStyle;
    }
  );
}

export default function EventDetailBanner({ title, shortContent }) {
  const contentWithoutColor = removeColorStyle(shortContent);
  console.log(shortContent, contentWithoutColor);
  return (
    <div className="w-full">
      <div className="w-full">
        <div
          className="block md:hidden lg:hidden w-full relative bg-center bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${time_mobi})`,
          }}
        >
          <div className="w-full bg-bggra1 ">
            <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-16 py-[20px] px-[20px]">
              <div className="w-full rounded-[40px] flex gap-1">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Tin tức & sự kiện
                  </p>
                </div>
                <div className="flex items-center gap-2 text-white font-normal">
                  <img src={ar_white} alt="a1" />
                  <p> Chi tiết tin tức</p>
                </div>
              </div>
              <div className="w-full">
                <p className="text-[28px] font-semibold text-white">{title}</p>
                <p className="text-white text-[16px] font-normal">
                  <span
                    className="!text-white"
                    dangerouslySetInnerHTML={{
                      __html: removeColorStyle(shortContent),
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="hidden md:block lg:block w-full relative h-[20rem] mt-1 bg-cover bg-no-repeat bg-center"
          style={{
            backgroundImage: `url(${time_pc})`,
          }}
        >
          <div className="w-full mx-auto h-[20rem] bg-bggra1 ">
            <div className=" flex flex-col gap-2 items-center justify-center w-full mx-auto pt-20">
              <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center ">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Tin tức & Sự kiện
                  </p>
                </div>
                <div className="flex items-center gap-2 text-white font-normal">
                  <img src={ar_white} alt="af" />
                  <p> Chi tiết tin tức</p>
                </div>
              </div>
              <div className="w-full text-center">
                <p className="text-[32px] font-semibold text-white">{title}</p>
                <p className="text-white text-[18px] font-normal text-center">
                  <span
                    className="!text-white"
                    dangerouslySetInnerHTML={{
                      __html: removeColorStyle(shortContent),
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
